var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"im-icon"},[_c('use',{attrs:{"xlink:href":`#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }